export default __webpack_public_path__ + "static/media/drawing-woman10-focusfill.f2dabbae.svg";